import { Button as MaterialButton, ButtonProps } from '@material-ui/core';
import React from 'react';
import { LinkProps } from 'react-router-dom';

import { Spinner } from '@components/Spinner';

interface IProps extends ButtonProps {
  component?: React.ElementType;
  submitting?: boolean;
}

export const Button: React.FC<IProps & Partial<LinkProps>> = ({
  submitting,
  children,
  startIcon,
  endIcon,
  ...props
}) => {
  const disabled = props.disabled || submitting || false;

  return (
    <MaterialButton
      {...props}
      startIcon={submitting ? undefined : startIcon}
      endIcon={submitting ? undefined : endIcon}
      disabled={disabled}
    >
      {submitting ? (
        <Spinner
          width={80}
          dotHeight={10}
          color={props.variant === 'contained' ? '#fff' : undefined}
        />
      ) : (
        children
      )}
    </MaterialButton>
  );
};
